<template>
  <section class="filters">
    <b-field grouped>
      <b-select placeholder="Select a type">
        <option
          v-for="type in types"
          :value="type.id"
          :key="type.id">
          {{ type.type }}
        </option>
      </b-select>

      <!-- Here I put @select-user to launch onUserSelect when event select-user is emitted (in UserSearch) -->
      <UserSearch @select-user="onUserSelect"/>
    </b-field>
  </section>
</template>

<script>
import ApiMatchs from '@/api/matchs'
import UserSearch from '@/components/UserSearch'
export default {
  components: {
    UserSearch
  },
  data () {
    return {
      types: [],
      filters: {
        user: null
      }
    }
  },
  methods: {
    onUserSelect (user) {
      this.filters.user = user
    }
  },
  created () {
    ApiMatchs.get.getMatchTypes().then(response => {
      this.types = response.body
    }).catch((error) => {
      throw error
    })
  }
}
</script>

<style scoped>
  .filters {
    background-color: lightgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/MatchFilters.vue